export default "__VITE_ASSET__CXHs6ocW__"